
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11 16.07V7.93002C11 7.12002 10.09 6.65002 9.41998 7.11002L3.64998 11.18C3.08998 11.58 3.08998 12.42 3.64998 12.81L9.41998 16.88C10.09 17.35 11 16.88 11 16.07ZM12.66 12.82L18.43 16.89C19.09 17.36 20.01 16.88 20.01 16.07V7.93002C20.01 7.12002 19.1 6.65002 18.43 7.11002L12.66 11.18C12.09 11.58 12.09 12.42 12.66 12.82Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-fast-rewind`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFastRewind

    ```js
    <b-new-b-icon-fast-rewind />
    ```
</docs>


